import { call, put } from 'redux-saga/effects'

import {
  fetchAlternativesFailure,
  fetchAlternativesSuccess
} from '../../actionCreators/alternatives/alternativesActionCreators'

import {
  fetchAvAlternativesFailure,
  fetchAvAlternativesSuccess
} from '../../actionCreators/avAlternatives/avAlternativesActionCreator'

import {
  fetchShopCollectionSuccess,
  fetchShopCollectionFailure
} from '../../actionCreators/shopCollection/shopCollectionActionCreators'

import getCookie from '../../helpers/getCookie'

const configData = {
  endpoint: '/recommendations-api',
  alternatives: {
    amcvCookie: 'AMCV_095C467352782EB30A490D45%40AdobeOrg',
    successAction: fetchAlternativesSuccess,
    failureAction: fetchAlternativesFailure
  },
  'av-alternatives': {
    amcvCookie: 'AMCV_095C467352782EB30A490D45%40AdobeOrg',
    successAction: fetchAvAlternativesSuccess,
    failureAction: fetchAvAlternativesFailure
  },
  shopCollection: {
    amcvCookie: 'AMCV_095C467352782EB30A490D45%40AdobeOrg',
    successAction: fetchShopCollectionSuccess,
    failureAction: fetchShopCollectionFailure
  }
}

function* alternativesSaga(action) {
  const {
    payload: { type, partNumber, localisation = {}, categoryId }
  } = action

  const { endpoint, [type]: relevantData } = configData
  const { amcvCookie, successAction: success, failureAction: failure } = relevantData
  const { postcode = '', storeId = '' } = localisation
  const postcodeFilter = relevantData.staticPostcode || postcode
  const postcodeParam = postcodeFilter ? `&postcode=${postcodeFilter}` : ''
  const storeIdParam = storeId ? `&storeId=${storeId}` : ''
  const decodedAmcvCookie = decodeURIComponent(getCookie(amcvCookie))
  const splitCookieArray = decodedAmcvCookie.split('|')
  const adobeId = splitCookieArray[2]
  const trackingId = adobeId ? `&trackingId=${adobeId}` : ''
  const channel = relevantData.channel || 'pdp'
  const categoryIdParam = relevantData.isCategoryIdRequired ? `&categoryId=${categoryId}` : ''

  try {
    const url = `${endpoint}?channel=${channel}&placement=${type}&itemId=${partNumber}${postcodeParam}${storeIdParam}${trackingId}${categoryIdParam}`
    const headers = new Headers({ Accept: 'application/vnd.recommendations+json' })
    const response = yield call(fetch, url, { headers })
    const jsonData = yield response.json()
    const successAction = success({ partNumber, ...jsonData })
    yield put(successAction)
  } catch (error) {
    const failureAction = failure({ partNumber, errorDetail: error })
    yield put(failureAction)
  }
}

export { alternativesSaga, configData }
